import React from 'react';
import DeploymentDashboard from './components/DeploymentDashboard';

function App() {
  return (
    <div className="container">
      <DeploymentDashboard />
    </div>
  );
}

export default App;